export default Object.freeze({
  Search: 1,
  Add: 2,
  Modify: 3,
  Remove: 4,
  Count: 5,
  Sum: 6,
  Subtraction: 7,
  Increment: 8,
  Decrement: 9,
  EvaluateFormula: 10,
});
